import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './order.reducer';

export const OrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const orderEntity = useAppSelector(state => state.order.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="orderDetailsHeading">Order</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{orderEntity.id}</dd>
          <dt>
            <span id="code">Code</span>
          </dt>
          <dd>{orderEntity.code}</dd>
          <dt>
            <span id="quantity">Quantity</span>
          </dt>
          <dd>{orderEntity.quantity}</dd>
          <dt>
            <span id="totalPrice">Total Price</span>
          </dt>
          <dd>{orderEntity.totalPrice}</dd>
          <dt>
            <span id="isApproved">Is Approved</span>
          </dt>
          <dd>{orderEntity.isApproved ? 'true' : 'false'}</dd>
          <dt>
            <span id="result">Result</span>
          </dt>
          <dd>{orderEntity.result}</dd>
          <dt>User</dt>
          <dd>{orderEntity.user ? orderEntity.user.id : ''}</dd>
          <dt>Mail Type</dt>
          <dd>{orderEntity.mailType ? orderEntity.mailType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/order/${orderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default OrderDetail;
